<template>
  <section
    class="sidearm-mm-hero text-white relative bg-size-cover bg-position-center relative overflow-hidden h-100"
    data-anchor="home"
  >
    <section-background css_var="--section-desktop-bg-selection-sunday-hero-win"></section-background>
    <div class="flex flex-align-center h-100 sidearm-mm-hero__inner">
      <div
        class="sidearm-mm-hero__details"
        :class="
          (game.result && game.result.boxscore) ||
          (game.story && game.story.url) ||
          (game.media && game.media.video)
            ? ''
            : 'no-margin'
        "
      >
        <ad
          name="tournament-experience-cs-hero-1"
          :sport-id="$root.sport_id"
          class="mb-2"
        />
        <!-- <img src="https://dummyimage.com/150x50/1C453B/ffffff" alt="" /> -->
        <h3 class="type-heading-bracket-plain --light my-0">
          {{ this.is_champion ? "National Champions" : round.title }}
        </h3>
        <h2 class="sidearm-mm-hero__school type-hero mt-0 mb-2">
          {{ school_name }}
          {{ this.is_champion || this.is_loss ? "" : "Advances" }}
        </h2>
        <p
          v-if="game.story && game.story.headline"
          class="type-paragraph-large my-0"
        >
          {{ game.story.headline }}
        </p>
        <p
          v-else-if="!is_champion && !is_loss"
          class="type-paragraph-large my-0"
        >
          {{ school_name }} {{ sport_name }} advances to the next round
        </p>
        <ul class="reset-list flex flex-align-center pt-1">
          <li v-if="game.result && game.result.boxscore" class="mr-2 pt-1">
            <a
              :href="game.result.boxscore"
              target="_blank"
              class="sidearm-mm-btn --ghost"
              >Box Score</a
            >
          </li>
          <li v-if="game.story && game.story.url" class="mr-2 pt-1">
            <a
              :href="game.story.url"
              target="_blank"
              class="sidearm-mm-btn --ghost"
              >Recap</a
            >
          </li>
          <li v-if="game.media && game.media.video">
            <div
              class="flex flex-align-center pt-1"
              @click="goto(game.media.video, true)"
            >
              <button
                type="button"
                class="sidearm-mm-play-btn"
                aria-label="Watch Highlights"
              >
                <icon>sf-play-minimal</icon>
              </button>
              <div class="type-paragraph mx-1">
                {{ this.game.media.video_text || "Watch Highlights" }}
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="sidearm-mm-hero__scoreboard">
        <div
          class="sidearm-mm-hero__scoreboard-inner w-100 flex flex-column flex-align-stretch"
        >
          <div
            class="sidearm-mm-hero__scoreboard-team sidearm-mm-hero__scoreboard-team flex flex-align-stretch"
            :class="
              !(
                (game.result &&
                  game.location_indicator === 'A' &&
                  game.result.status === 'W') ||
                (game.location_indicator !== 'A' && game.result.status !== 'W')
              )
                ? 'sidearm-mm-hero__scoreboard-team--loser'
                : ''
            "
          >
            <div
              class="sidearm-mm-hero__scoreboard-logo sidearm-mm-hero__scoreboard-field col-4-of-8 flex flex-align-center relative"
            >
              <span
                v-if="has_both_seeds"
                class="type-heading-bracket-small --light mr-1"
              >
                {{
                  game.location_indicator === "A"
                    ? $root.data.team.seed
                    : game.opponent.seed
                }}
              </span>
              <img
                v-if="game.location_indicator === 'A'"
                :src="$root.school_logo(120, 120)"
                :alt="
                  $root.data.school.name
                    ? $root.data.school.name
                    : 'School Logo'
                "
              />
              <img
                v-else
                :src="
                  game.opponent &&
                  game.opponent.image &&
                  game.opponent.image.url
                    ? `${$root.absolutize_cdn(
                        game.opponent.image.url
                      )}?width=120&height=120`
                    : `${$root.school_logo(120, 120)}&s.grayscale=100`
                "
                :alt="game.opponent ? game.opponent.title : 'Opponent Logo'"
              />
            </div>
            <div
              class="sidearm-mm-hero__scoreboard-result  sidearm-mm-hero__scoreboard-field col-4-of-8 flex flex-align-center flex-justify-center"
            >
              <div
                class="sidearm-mm-hero__scoreboard-score type-hero-small flex flex-align-center flex-justify-center text-center"
              >
                {{
                  game.location_indicator === "A"
                    ? game.result.team_score
                    : game.result.opponent_score
                }}
              </div>
            </div>
          </div>
          <div
            class="sidearm-mm-hero__scoreboard-team flex flex-align-stretch"
            :class="
              !(
                (game.result &&
                  game.location_indicator !== 'A' &&
                  game.result.status === 'W') ||
                (game.location_indicator === 'A' && game.result.status !== 'W')
              )
                ? 'sidearm-mm-hero__scoreboard-team--loser'
                : ''
            "
          >
            <div
              class="sidearm-mm-hero__scoreboard-logo sidearm-mm-hero__scoreboard-field col-4-of-8 flex flex-align-center flex-justify-end relative"
            >
              <span
                v-if="has_both_seeds"
                class="type-heading-bracket-small --light  mr-1"
              >
                {{
                  game.location_indicator !== "A"
                    ? $root.data.team.seed
                    : game.opponent.seed
                }}
              </span>
              <img
                v-if="game.location_indicator !== 'A'"
                :src="$root.school_logo(120, 120)"
                :alt="
                  $root.data.school.name
                    ? $root.data.school.name
                    : 'School Logo'
                "
              />
              <img
                v-else
                :src="
                  game.opponent &&
                  game.opponent.image &&
                  game.opponent.image.url
                    ? `${$root.absolutize_cdn(
                        game.opponent.image.url
                      )}?width=120&height=120`
                    : `${$root.school_logo(120, 120)}&s.grayscale=100`
                "
                :alt="game.opponent ? game.opponent.title : 'Opponent Logo'"
              />
            </div>
            <div
              class="sidearm-mm-hero__scoreboard-result sidearm-mm-hero__scoreboard-field col-4-of-8 flex flex-align-center flex-justify-center"
            >
              <div
                class="sidearm-mm-hero__scoreboard-score type-hero-small flex flex-align-center flex-justify-center text-center"
              >
                {{
                  game.location_indicator !== "A"
                    ? game.result.team_score
                    : game.result.opponent_score
                }}
              </div>
            </div>
          </div>
          <a class="sidearm-mm-btn --primary text-center" href="#tournament-run"
            >Tournament Run &amp; History <icon>sf-arrows-thick-right</icon></a
          >
        </div>
      </div>
      <canvas id="canvas" class="confetti"></canvas>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    round: { type: [Object, null], required: true }
  },
  data: () => ({
    animation_speed: "20s",
    school_name: "",
    sport_name: ""
  }),
  computed: {
    game() {
      if (!this.round) {
        return null;
      }
      return this.round.game;
    },
    has_both_seeds() {
      return (
        this.$root.data.team.seed &&
        this.game.opponent &&
        this.game.opponent.seed &&
        +this.game.opponent.seed <= 16
      );
    },
    is_champion() {
      try {
        return this.round.round === 2 && this.round.game.result.status === "W";
      } catch {
        return false;
      }
    },
    is_loss() {
      try {
        return this.round.game.result.status !== "W";
      } catch {
        return false;
      }
    }
  },
  methods: {
    init_canvas() {
      //-----------Var Inits--------------
      let canvas = document.getElementById("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      let confetti = [];
      const confettiCount = 300;
      const gravity = 0.5;
      const terminalVelocity = 5;
      const drag = 0.075;

      const colors = [
        {
          front: "#a1a8ad", //gray
          back: "#a1a8ad"
        },
        {
          front: window.site_colors.primary_background,
          back: window.site_colors.primary_background
        },
        {
          front: window.site_colors.secondary_background,
          back: window.site_colors.secondary_background
        }
      ];

      //-----------Functions--------------
      const resizeCanvas = () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      };

      const randomRange = (min, max) => Math.random() * (max - min) + min;

      const initConfetti = () => {
        for (let i = 0; i < confettiCount; i++) {
          confetti.push({
            color: colors[Math.floor(randomRange(0, colors.length))],
            dimensions: {
              x: randomRange(6, 10),
              y: randomRange(6, 12)
            },
            position: {
              x: randomRange(0, canvas.width),
              y: canvas.height - 1
            },
            rotation: randomRange(0, 2 * Math.PI),
            scale: {
              x: 1,
              y: 1
            },
            velocity: {
              x: randomRange(-25, 25),
              y: randomRange(0, -50)
            }
          });
        }
      };

      //---------Render-----------
      const render = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        confetti.forEach((confetto, index) => {
          let width = confetto.dimensions.x * confetto.scale.x;
          let height = confetto.dimensions.y * confetto.scale.y;

          // Move canvas to position and rotate
          ctx.translate(confetto.position.x, confetto.position.y);
          ctx.rotate(confetto.rotation);

          // Apply forces to velocity
          confetto.velocity.x -= confetto.velocity.x * drag;
          confetto.velocity.y = Math.min(
            confetto.velocity.y + gravity,
            terminalVelocity
          );
          confetto.velocity.x +=
            Math.random() > 0.5 ? Math.random() : -Math.random();

          // Set position
          confetto.position.x += confetto.velocity.x;
          confetto.position.y += confetto.velocity.y;

          // Delete confetti when out of frame
          if (confetto.position.y >= canvas.height) confetti.splice(index, 1);

          // Loop confetto x position
          if (confetto.position.x > canvas.width) confetto.position.x = 0;
          if (confetto.position.x < 0) confetto.position.x = canvas.width;

          // Spin confetto by scaling y
          confetto.scale.y = Math.cos(confetto.position.y * 0.1);
          ctx.fillStyle =
            confetto.scale.y > 0 ? confetto.color.front : confetto.color.back;

          // Draw confetto
          ctx.fillRect(-width / 2, -height / 2, width, height);

          // Reset transform matrix
          ctx.setTransform(1, 0, 0, 1, 0, 0);
        });

        // Fire off another round of confetti
        if (confetti.length <= 10) initConfetti();

        window.requestAnimationFrame(render);
      };

      //---------Execution--------
      initConfetti();
      render();

      //----------Resize----------
      window.addEventListener("resize", function() {
        resizeCanvas();
      });

      //------------Click------------
      window.addEventListener("click", function() {
        initConfetti();
      });
    }
  },
  mounted() {
    this.school_name = this.$root.data.school.name;
    this.sport_name = this.$root.data.sport.title;
    if (
      this.is_champion &&
      window.site_colors &&
      window.site_colors.primary_background &&
      window.site_colors.secondary_background
    ) {
      this.init_canvas();
    }
  }
};
</script>

<style lang="scss" scoped>
.confetti {
  position: fixed;
  z-index: 0;
}
.sidearm-mm-hero__details,
a,
button {
  z-index: 1;
}
.no-margin {
  margin-bottom: 0 !important;
}
.sidearm-mm-play-btn {
  @include play-btn(3.75rem);
}
.sidearm-mm-hero {
  &__inner {
    padding: 120px 12px 0;
    flex-direction: column;
  }

  &__school {
    font-size: 2.5rem;
  }
  &__details {
    width: 100%;

    ul {
      flex-wrap: wrap;
    }
  }

  &__divider {
    > span {
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
    }

    &::before,
    &::after {
      background-color: $color-white;
      content: "";
      display: block;
      position: absolute;
      top: 50%;
    }

    &::before {
      height: 1px;
      left: 1.5rem;
      width: calc(100% - 1.5rem);
    }

    &::after {
      height: 100vh;
      right: 0;
      width: 1px;
    }
  }

  &__scoreboard {
    margin-top: 48px;
    &-inner {
      padding: 0 24px;
    }
    &-field {
      padding: 12px;
    }
    &-logo {
      @include flex-item(0 1 auto);
      margin: 0 1px 1px 0;
      background: rgba($color-black, 0.5);
      justify-content: end;
      justify-content: center;

      img {
        width: 48px;
        object-fit: cover;
      }
    }
    &-team--loser {
      .sidearm-mm-hero__scoreboard-score::before {
        display: none;
      }
      .sidearm-mm-hero__scoreboard-score::after {
        background-color: $color-black;
      }
    }
    &-result {
      @include flex-item(0 1 auto);
      margin: 0 0 1px 0;
      background: rgba($color-black, 0.5);
    }
    &-score {
      position: relative;
      &::before {
        position: absolute;
        top: 50%;
        font-size: 1rem;
        right: 100%;
        content: "\e010";
        font-family: $font-icons;
        transform: translate(-#{grid_percent(30)}, -50%);
      }
    }
  }
  @media screen and (min-width: 768px) {
    &__inner {
      padding: 180px 24px 24px;
    }
    &__school {
      font-size: 5rem;
    }
    &__details {
      margin-bottom: auto;
    }
    &__scoreboard {
      margin-top: 0;
      &-field {
        padding: 24px;
      }
      &-logo img {
        width: 80px;
      }
    }
  }
  @media screen and (min-width: 1028px) {
    &__inner {
      padding: 180px 0 0;
      flex-direction: row;
    }
    &__details {
      width: 37.5%;
      margin-left: 12.5%;
    }
    &__school {
      font-size: 6rem;
    }
    &__details {
      margin-bottom: 0;
    }
    &__scoreboard {
      width: 37.5%;
      margin-left: 12.5%;
      &-inner {
        padding: 0 calc(#{grid_percent(60)} + 60px) 0 #{grid_percent(60)};
      }
      &-field {
        padding: 36px #{grid_percent(60)};
      }
      &-logo img {
        width: auto;
      }
    }
  }
}
</style>
